<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35">
    <g>
      <path
        d="M11.159,33.806c-9.006-3.502-13.466-13.64-9.966-22.648C4.696,2.151,14.837-2.309,23.841,1.195
		c9.006,3.498,13.466,13.644,9.966,22.646C30.304,32.848,20.163,37.308,11.159,33.806"
      />
      <g>
        <path
          fill="#FFFFFF"
          d="M19.833,6.246c0.684,0.108,1.282,0.241,1.792,0.4c0.512,0.16,0.947,0.332,1.307,0.518
			c0.361,0.186,0.656,0.36,0.885,0.527c0.23,0.165,0.396,0.308,0.504,0.429c0.106,0.117,0.167,0.186,0.179,0.196
			c0.074,0.103,0.136,0.219,0.184,0.352c0.045,0.136,0.067,0.262,0.061,0.381v1.622c0,0.175-0.058,0.321-0.17,0.433
			c-0.081,0.081-0.177,0.096-0.285,0.109c-0.11,0.016-3.252,0-3.252,0c-0.156-0.042-0.282-0.137-0.376-0.281
			c-0.094-0.144-0.141-0.296-0.141-0.461V9.549c0-0.025-0.009-0.057-0.029-0.095c-0.019-0.039-0.035-0.064-0.057-0.084
			c-0.154-0.106-0.36-0.202-0.621-0.281c-0.225-0.075-0.524-0.144-0.896-0.204c-0.374-0.059-0.846-0.084-1.418-0.078
			c-0.568-0.006-1.042,0.02-1.415,0.078c-0.373,0.061-0.672,0.129-0.897,0.204c-0.259,0.079-0.464,0.175-0.621,0.281
			c-0.019,0.02-0.037,0.045-0.056,0.084c-0.02,0.038-0.028,0.069-0.028,0.095v0.922c0,0.165-0.047,0.317-0.14,0.461
			c-0.097,0.145-0.22,0.239-0.378,0.281c0,0-3.142,0.016-3.25,0c-0.108-0.014-0.206-0.028-0.289-0.109
			c-0.11-0.111-0.168-0.258-0.168-0.433V9.049c-0.004-0.119,0.014-0.245,0.062-0.381c0.048-0.133,0.105-0.249,0.183-0.352
			c0.014-0.011,0.071-0.079,0.181-0.196c0.104-0.121,0.272-0.264,0.501-0.429c0.228-0.167,0.523-0.342,0.886-0.527
			c0.359-0.186,0.796-0.357,1.307-0.518c0.511-0.159,1.107-0.292,1.792-0.4c0.682-0.104,1.46-0.156,2.331-0.148
			C18.371,6.09,19.149,6.142,19.833,6.246z"
        />
        <polygon
          fill="#FFFFFF"
          points="23.026,24.018 23.026,28.901 11.826,28.901 11.826,24.018 11.826,20.766 23.026,20.766 		"
        />
        <path
          fill="#FFFFFF"
          d="M25.939,22.957h-1.408v-2.335v-1.168H10.469v1.168v2.335H9.061c-1.405,0-2.812-1.168-2.812-2.335v-5.845
			c0-1.166,1.407-2.334,2.812-2.334h1.408h14.062h1.408c1.407,0,2.812,1.168,2.812,2.334v5.845
			C28.752,21.789,27.347,22.957,25.939,22.957z M21.385,18.148c0.312,0,0.571-0.255,0.571-0.57c0-0.314-0.259-0.569-0.571-0.569
			c-0.315,0-0.573,0.255-0.573,0.569C20.812,17.894,21.069,18.148,21.385,18.148z M21.385,16.625c0.312,0,0.571-0.253,0.571-0.569
			c0-0.314-0.259-0.57-0.571-0.57c-0.315,0-0.573,0.256-0.573,0.57C20.812,16.372,21.069,16.625,21.385,16.625z M21.385,15.104
			c0.312,0,0.571-0.254,0.571-0.568c0-0.315-0.259-0.572-0.571-0.572c-0.315,0-0.573,0.257-0.573,0.572
			C20.812,14.85,21.069,15.104,21.385,15.104z M19.861,18.148c0.316,0,0.571-0.255,0.571-0.57c0-0.314-0.255-0.569-0.571-0.569
			c-0.314,0-0.569,0.255-0.569,0.569C19.292,17.894,19.547,18.148,19.861,18.148z M19.861,16.625c0.316,0,0.571-0.253,0.571-0.569
			c0-0.314-0.255-0.57-0.571-0.57c-0.314,0-0.569,0.256-0.569,0.57C19.292,16.372,19.547,16.625,19.861,16.625z M19.861,15.104
			c0.316,0,0.571-0.254,0.571-0.568c0-0.315-0.255-0.572-0.571-0.572c-0.314,0-0.569,0.257-0.569,0.572
			C19.292,14.85,19.547,15.104,19.861,15.104z M18.341,18.148c0.313,0,0.568-0.255,0.568-0.57c0-0.314-0.255-0.569-0.568-0.569
			c-0.317,0-0.572,0.255-0.572,0.569C17.769,17.894,18.023,18.148,18.341,18.148z M18.341,16.625c0.313,0,0.568-0.253,0.568-0.569
			c0-0.314-0.255-0.57-0.568-0.57c-0.317,0-0.572,0.256-0.572,0.57C17.769,16.372,18.023,16.625,18.341,16.625z M15.138,16.625
			c0.317,0,0.571-0.253,0.571-0.569c0-0.314-0.254-0.57-0.571-0.57c-0.312,0-0.569,0.256-0.569,0.57
			C14.568,16.372,14.825,16.625,15.138,16.625z M13.617,16.625c0.315,0,0.57-0.253,0.57-0.569c0-0.314-0.255-0.57-0.57-0.57
			c-0.314,0-0.57,0.256-0.57,0.57C13.047,16.372,13.303,16.625,13.617,16.625z M18.341,15.104c0.313,0,0.568-0.254,0.568-0.568
			c0-0.315-0.255-0.572-0.568-0.572c-0.317,0-0.572,0.257-0.572,0.572C17.769,14.85,18.023,15.104,18.341,15.104z"
        />
      </g>
    </g>
  </svg>
</template>
